<nav *ngIf="isEnabled('nav')">
    <a routerLink="/play" routerLinkActive="active">Play</a>
    <!--<a routerLink="/account" routerLinkActive="active">Account</a>-->
    <!--<a routerLink="/profile" routerLinkActive="active">Profile</a>-->
    <!--<a routerLink="/register" routerLinkActive="active">Register</a>-->
    <!--<a routerLink="/login" routerLinkActive="active">Login</a>-->
    <!--<a routerLink="/invite" routerLinkActive="active">Invite</a>-->
</nav>
<router-outlet></router-outlet>
